module.exports = __webpack_public_path__ + "img/AnnualReport.505ba025.png";